"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const bcp_1 = require("@iov/bcp");
const conditions_1 = require("./conditions");
const encodemsg_1 = require("./encodemsg");
const encodinghelpers_1 = require("./encodinghelpers");
const codecImpl = __importStar(require("./generated/codecimpl"));
const types_1 = require("./types");
const util_1 = require("./util");
function encodePubkey(pubkey) {
    switch (pubkey.algo) {
        case bcp_1.Algorithm.Ed25519:
            if (pubkey.data.length !== 32) {
                throw new Error("Invalid pubkey size: must be 32 bytes");
            }
            return { ed25519: pubkey.data };
        default:
            throw new Error("unsupported algorithm: " + pubkey.algo);
    }
}
exports.encodePubkey = encodePubkey;
function encodePrivkey(privkey) {
    switch (privkey.algo) {
        case bcp_1.Algorithm.Ed25519:
            return { ed25519: privkey.data };
        default:
            throw new Error("unsupported algorithm: " + privkey.algo);
    }
}
exports.encodePrivkey = encodePrivkey;
function encodeSignature(algo, bytes) {
    switch (algo) {
        case bcp_1.Algorithm.Ed25519:
            return { ed25519: bytes };
        default:
            throw new Error("unsupported algorithm: " + algo);
    }
}
function encodeFullSignature(fullSignature) {
    return codecImpl.sigs.StdSignature.create({
        sequence: fullSignature.nonce,
        pubkey: encodePubkey(fullSignature.pubkey),
        signature: encodeSignature(fullSignature.pubkey.algo, fullSignature.signature),
    });
}
exports.encodeFullSignature = encodeFullSignature;
function encodeFeeForTx(txWithFee) {
    var _a;
    const { fee } = txWithFee;
    if (!((_a = fee) === null || _a === void 0 ? void 0 : _a.tokens)) {
        throw new Error("Cannot build fee for transaction without fee tokens");
    }
    let feePayerAddressBytes;
    if (fee.payer) {
        feePayerAddressBytes = util_1.decodeBnsAddress(fee.payer).data;
    }
    else if (types_1.isMultisignatureTx(txWithFee)) {
        const firstContract = txWithFee.multisig.find(() => true);
        if (firstContract === undefined)
            throw new Error("Empty multisig arrays are currently unsupported");
        feePayerAddressBytes = conditions_1.conditionToWeaveAddress(conditions_1.buildMultisignatureCondition(firstContract));
    }
    else {
        throw new Error("Cannot build fee for transaction with unknown fee payer");
    }
    return {
        fees: encodinghelpers_1.encodeAmount(fee.tokens),
        payer: feePayerAddressBytes,
    };
}
function encodeUnsignedTx(tx) {
    const msg = encodemsg_1.encodeMsg(tx);
    return codecImpl.bnsd.Tx.create(Object.assign(Object.assign({}, msg), { fees: tx.fee ? encodeFeeForTx(tx) : null, multisig: types_1.isMultisignatureTx(tx) ? tx.multisig.map(encodinghelpers_1.encodeNumericId) : null }));
}
exports.encodeUnsignedTx = encodeUnsignedTx;
function encodeSignedTx(tx) {
    const built = encodeUnsignedTx(tx.transaction);
    return Object.assign(Object.assign({}, built), { signatures: tx.signatures.map(encodeFullSignature) });
}
exports.encodeSignedTx = encodeSignedTx;
//# sourceMappingURL=encode.js.map